module.exports = __webpack_public_path__ + "static/media/icon-satisfeito.f0b3fcb6.svg";